export function Loading({ label = 'Loading your cover…' }: { label?: string }) {
  return (
    <div className="overlay overlay--center" aria-live="polite">
      <div className="loader">
        <div className="loader__spinner" />
        <div className="loader__label">{label}</div>
      </div>
    </div>
  )
}

export function ErrorOverlay({ message }: { message: string }) {
  return (
    <div className="overlay overlay--center">
      <div className="error-card">
        <div className="error-card__title">Couldn’t load the 3D preview</div>
        <div className="error-card__detail">{message}</div>
      </div>
    </div>
  )
}

/** Shown when the requested cover-type + size combination has no 3D model. */
export function UnavailableOverlay({ message }: { message: string }) {
  return (
    <div className="overlay overlay--center">
      <div className="error-card">
        <div className="error-card__title">3D model not available</div>
        <div className="error-card__detail">{message}</div>
      </div>
    </div>
  )
}
